import { WorkspaceRoleKey } from 'hooks/internalApi';

export const workspaceRoleLabels: Record<WorkspaceRoleKey, string> = {
  [WorkspaceRoleKey.WorkspaceReader]: 'Reader',
  [WorkspaceRoleKey.WorkspaceAdmin]: 'Admin',
  [WorkspaceRoleKey.FreeTierReader]: 'Reader',
  [WorkspaceRoleKey.FreeTierAdmin]: 'Admin',
};
